module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Close-21044a0c02b75af40c1c0e26e2128182.svg";